import { Box, Chip, Grid } from "@mui/material";
import './TagCell.css';

export const TagsCell = ({ flags, status, hasKeyWords, goToKeyWordPage }: { flags?: { [key: string]: [string], risk: [string], protective: [string] }, status: string | null | undefined, hasKeyWords: boolean, goToKeyWordPage: () => void }) => {
  if (flags) {
    const tags = Object.keys(flags)
      .flatMap((type: string) => flags[type].map((name: string) => ({ type, name })))
      .sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
      .map((tuple) =>
        <Grid key={`tags-chip-${tuple.type}-${tuple.name}`} style={{ marginTop: 1 }}>
          <Chip
            className={`chip ${tuple.type}`}
            label={tuple.name}
            data-state={(status === 'Unread') && tuple.name.toLocaleUpperCase() === 'SUICIDALITY' ? 'on' : 'off'} />

          {/* data-state={(!status||status === 'Unread') && tuple.name.toLocaleUpperCase() === 'SUICIDALITY' ? 'on' : 'off'} /> */}
        </Grid>
      );
    const KeyWordChip = ({ handleClick }: { handleClick: () => void }) => {
      return (<Grid style={{ marginTop: 1, zIndex: 10 }}>
        <Chip className={`chip keyword`}
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e: React.MouseEvent<HTMLDivElement>) => {
            // e.stopPropagation();
            // console.log("stopping the prop")
            handleClick();
          }}
          tabIndex={-1}
          clickable
          data-state={(status === 'Unread') ? 'on' : 'off'}

          // data-state={(!status || status === 'Unread') ? 'on' : 'off'}
          label='Needs Review' />
      </Grid>)
    }

    return (
      <Grid container spacing={1} sx={{ padding: 2, justifyContent: "center" }} >
        {hasKeyWords ? <KeyWordChip handleClick={goToKeyWordPage} /> : <></>}
        {tags}
      </Grid>
    );
  }

  return (
    <Box component="div" sx={{ width: "100%", textAlign: "center", padding: 2, marginTop: 1 }}>
      --
    </Box>
  );
}